import { Box } from '@mui/material';
import cx from 'clsx';
import { iconBtnStyle, iconBtnType, IconButton } from '../../../../../../packages';
import { useStyles } from './BottomView.styles';

const BottomView = ({
  isVideoCall,
  isAudio,
  isSharing,
  toggleVideCall,
  toggleMic,
  onShareScreenClick,
  onStopSharingClick,
  hidden,
  disableScreenShare = false,
  showScratchpadButton = false,
  onScratchpadClick,
}) => {
  const classes = useStyles();

  const onShareClick = () => {
    if (disableScreenShare) return;
    if (isSharing) {
      onStopSharingClick();
    } else {
      onShareScreenClick();
    }
  };

  if (hidden) {
    return null;
  }

  return (
    <Box className={classes.bottomView}>
      <Box className={classes.container}>
        <Box className={classes.actions}>
          {showScratchpadButton && (
            <IconButton
              disableRipple
              variant={iconBtnType.PRIMARY}
              style={iconBtnStyle.DARK}
              className={classes.iconBtn}
              onClick={onScratchpadClick}
              icon="scratchpad-filled"
            />
          )}
          <IconButton
            disableRipple
            variant={iconBtnType.PRIMARY}
            style={iconBtnStyle.DARK}
            className={cx(classes.iconBtn, {
              [classes.shareActive]: isSharing,
              [classes.disabled]: disableScreenShare,
            })}
            onClick={onShareClick}
            icon="share-screen"
            disabled={disableScreenShare}
          />
          <IconButton
            disableRipple
            variant={iconBtnType.PRIMARY}
            style={iconBtnStyle.DARK}
            className={cx(classes.iconBtn /*, { [classes.videoActive]: isVideoCall } */)}
            icon={isVideoCall ? 'camera-filled' : 'camera-off'}
            onClick={toggleVideCall}
          />
          <IconButton
            disableRipple
            variant={iconBtnType.PRIMARY}
            style={iconBtnStyle.DARK}
            className={cx(classes.iconBtn /* , { [classes.AudioActive]: isAudio } */)}
            onClick={toggleMic}
            icon={isAudio ? 'mic-on' : 'mic-off'}
          />
        </Box>
      </Box>
    </Box>
  );
};

export { BottomView };
